<template>
  <div>
    <div class="device-setting-container">
      <div class="device-set-preview-option-title-wrapper">
        <h3 class="device-set-preview-option-title video">{{ $t("common.device.camera") }}</h3>
        <span v-if="devices.videoinput.length > 0">{{ $t("common.device.workingNormally") }}</span>
        <span v-else>{{ $t("common.device.videoInputDeviceNotFound") }}</span>
      </div>
      <div class="device-set-preview-option-select-wrapper"
       v-if="devices.videoinput.length > 0">
        <select class="form-select"
                v-model="selectedDevice.videoinput.deviceId"
                @change="onChangeVideoDevice">
          <option v-for="device in devices.videoinput"
                  :value="device.deviceId"
                  :key="device.deviceId"
                  :class="{selected: device.deviceId === selectedDevice.videoinput.deviceId}"
          >{{device.label}}</option>
        </select>
      </div>
    </div>
<!--
    <div class="device-setting-container"
         v-if="devices.audiooutput.length > 0"
    >
      <div class="device-set-preview-option-title-wrapper">
        <h3 class="device-set-preview-option-title audiooutput">{{ $t("common.device.speaker") }}</h3>
        <span>{{ $t("common.device.workingNormally") }}</span>
      </div>
      <div class="device-set-preview-option-select-wrapper">
        <select class="form-select"
                v-model="selectedDevice.audiooutput.deviceId"
                @input="onChangeDevice('audiooutput', $event.target.value)">
          <option v-for="device in devices.audiooutput"
                  :value="device.deviceId"
                  :key="device.deviceId">{{device.label}}</option>
        </select>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import {Device} from "@/utils";
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";
import _ from "lodash";

export default {
  name: 'DeviceSetting',
  data() {
    return {
      selectedDevice: {
        videoinput: {
          deviceId: ''
        },
        audiooutput: {
          deviceId: null
        }
      },
      devices: {
        videoinput: [],
        audiooutput: []
      }
    }
  },
  computed: {
    ...mapGetters('room', [
      'deviceSettings',
    ])
  },
  created () {
    navigator.mediaDevices?.addEventListener('devicechange', this.loadDevices);

    if(this.$parent.selectedDevice){
      const psd = this.$parent.selectedDevice;
      const video = psd.video || psd.videoinput;
      const audiooutput = psd.audiooutput;

      video && _.merge(this.selectedDevice.videoinput, video);
      audiooutput && _.merge(this.selectedDevice.audiooutput, audiooutput);
    }

    this.loadDevices();
  },
  destroyed () {
    navigator.mediaDevices?.removeEventListener('devicechange', this.loadDevices);
  },
  methods: {
    ...mapMutations('room',[
      'SET_DEVICES',
    ]),
    async loadDevices () {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const data = devices.reduce((data, device) => {
        data[device.kind]?.push(device.toJSON());
        return data;
      }, {
        videoinput: [],
        // audiooutput: []
      });

      if(!this.selectedDevice.videoinput.deviceId){
        this.selectedDevice.videoinput.deviceId = data.videoinput[0].deviceId;
      }
      Object.assign(this.devices, data);
    },
    async onChangeVideoDevice() {
      let deviceId = this.selectedDevice.videoinput.deviceId;
      let device = this.devices.videoinput.find(device => device.deviceId == deviceId);
      console.log('# select video device :', deviceId, device);

      if(!device) return;
      Object.assign(this.selectedDevice.videoinput, device);
      await this.$parent.previewVideo(device.deviceId);
    },
  }
}
</script>

<style scoped lang="scss">
.device-setting-container{
  width: 100%;
  padding: 10px 20px 0;
}
.device-set-preview-option-title-wrapper{
  display: flex;
  align-items: center;
  color: white;
  .device-set-preview-option-title{
    padding-left: 28px;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;

    &.video{
      background: url("~@/assets/images/camstudy/ico_device_video.svg") no-repeat left 3px center;
    }
    &.audiooutput{
      background: url("~@/assets/images/camstudy/ico_device_audiooutput.svg") no-repeat left 3px center;
    }
  }
  span{
    font-size: 12px;
    line-height: 16px;
    color: #999;
    margin-left: 20px;
  }
}
.device-set-preview-option-select-wrapper{
  color: white;
  margin-top: 6px;
}
.device-setting-container + .device-setting-container{
  margin-top: 30px;
}
.form-select{
  width: 100%;
  outline: transparent;
  font-size: 14px;
  line-height: 1.6;
  background-color: transparent;

  option {
    color: #000;
    background: transparent;
    &.selected {
      background-color: #ccc;
    }
  }
}
@keyframes bottomUp {
  0%{
    bottom: -100%;
  }
  100%{
    bottom: 0;
  }
}
</style>